import type { Preview3DConfig } from './preview3d'

export const PREVIEW_MATERIAL_CANVAS_WOOD: Partial<Preview3DConfig> = {
  defaultMaterialMode: 'canvas',
  defaultShowFrame: true,
}

